import React from 'react'
import { faReceipt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IOrderCheck } from './IOrder'

interface ICheckListProps {
  checks: IOrderCheck[]
}

const CheckList: React.FC<ICheckListProps> = ({ checks }) => {
  return (
    <div>
      {checks.map((check) => {
        return check.full_url ? (
          <a
            key={check.check_id}
            className='my-link'
            target='_blank'
            href={check.full_url}
            rel='noreferrer'
          >
            <FontAwesomeIcon icon={faReceipt} />
            Чек на {check.type_name_rp}
          </a>
        ) : null
      })}
    </div>
  )
}
export default CheckList
